<template>
  <div
    class="szyIndex"
    v-loading="loading"
    :style="{ 'background-color': isMobile ? '#fff' : '#fff' }"
  >
    <szyCarousel v-if="!isMobile"></szyCarousel>
    <div class="szyIndex_main w1200" :class="{ isMobile: isMobile }">
      <div class="content_carousel">
        <div class="carousel_left" v-if="!isMobile">
          <div
            v-for="(item, index) in homepageData.headlineList"
            :key="index"
            class="big_img pointer"
          >
            <img
              :src="baseUrl + item.picture"
              alt=""
              v-show="index === counter"
            />
          </div>
          <div class="small_list">
            <div
              v-for="(item, index) in homepageData.headlineList"
              :key="index"
              class="small_img pointer"
              @mouseenter="onmouseover(index)"
              @mouseleave="startInfiniteLoop"
            >
              <img :src="baseUrl + item.picture" alt="" />
              <span v-show="index === counter">▲</span>
            </div>
          </div>
        </div>
        <div class="carousel_right">
          <div class="right_header">
            <div class="title">新闻头条</div>
            <div
              class="more pointer"
             
            >
              更多>
            </div>
          </div>
          <div class="right_title pointer">
            {{ homepageData.headlineList[counter].title }}
          </div>
          <div class="right_content">
            {{ homepageData.headlineList[counter].content }}
          </div>
          <div class="right_footer">
            <div
              class="detail pointer"
             
            >
              查看详情
            </div>
            <div class="time">
              发布时间：{{
                changeMoment(homepageData.headlineList[counter].updateTime)
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="h3_title">
        <span style="color: #b50000; font-size: 24px">新闻</span>中心<span
          style="color: #ccc; margin-left: 5px"
          >NEWS</span
        >
      </div>
      <div class="news_center">
        <div class="center_left">
          <div class="center_title">
            <div
              @mouseenter="centerNum = 0"
              class="pointer"
              :class="{ highlight: centerNum === 0 }"
              
            >
              公司新闻
            </div>
            <div
              @mouseenter="centerNum = 1"
              class="pointer"
              :class="{ highlight: centerNum === 1 }"
             
            >
              信息披露
            </div>
            <div
              @mouseenter="centerNum = 2"
              class="pointer"
              :class="{ highlight: centerNum === 2 }"
              
            >
              脱贫攻坚
            </div>
          </div>
          <div class="left_content">
            <div v-if="centerNum === 0">
              <div v-for="(item, index) in homepageData.newsList" :key="index">
                <div class="list_card0" v-if="index === 0 && !isMobile">
                  <div class="images">
                    <img :src="baseUrl + item.picture" alt="" />
                  </div>
                  <div class="card_content">
                    <div
                      class="title"
                      
                    >
                      {{ item.title }}
                    </div>
                    <div class="content">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
                <div class="list_card" v-else>
                  <div
                    class="card_title"
                    
                  >
                    <span class="dian"></span>{{ item.title }}
                  </div>
                  <div class="card_time" v-if=" !isMobile">
                    {{ changeMoment(item.inputTime) }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="centerNum === 1">
              <div
                class="list_card"
                v-for="(item, index) in homepageData.disclosureList"
                :key="index"
              >
                <div
                  class="card_title"
                  
                >
                  <span class="dian"></span>{{ item.title }}
                </div>
                <div class="card_time" v-if=" !isMobile">{{ changeMoment(item.inputTime) }}</div>
              </div>
            </div>
            <div v-if="centerNum === 2">
              <div
                v-for="(item, index) in homepageData.povertyList"
                :key="index"
              >
                <div class="list_card0" v-if="index === 0 &&  !isMobile">
                  <div class="images">
                    <img :src="baseUrl + item.picture" alt="" />
                  </div>
                  <div class="card_content">
                    <div
                      class="title"
                      
                    >
                      {{ item.title }}
                    </div>
                    <div class="content">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
                <div class="list_card" v-else>
                  <div
                    class="card_title"
                    
                  >
                    <span class="dian"></span>{{ item.title }}
                  </div>
                  <div class="card_time" v-if=" !isMobile">
                    {{ changeMoment(item.inputTime) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="scroll_content">
          <div class="center_title">
            <div class="pointer" style="font-size: 16px">
              子公司动态 <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <vue-seamless-scroll
            :data="homepageData.dynamicList"
            class="seamless-warp"
          >
            <ul>
              <li
                v-for="(item, index) in homepageData.dynamicList"
                :key="index"
                class="item pointer"
                
              >
                <span class="copyFrom">{{ item.copyFrom }}</span>
                <span class="line"></span>
                <span class="title">{{ item.title }}</span>
                <span class="date" v-if="!isMobile"> {{ changeMoment(item.inputTime) }}</span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <div class="szyIndex_main special" v-if="!isMobile">
      <div class="w1200 content">
        <div class="h3_title special_title">
          <div>
            <span style="color: #b50000; font-size: 24px">专题</span
            ><span style="font-size: 24px">专栏</span
            ><span style="color: #ccc; margin-left: 5px">SPECIAL</span>
          </div>
          <div class="gengduo" >
            更多专栏内容&gt;
          </div>
        </div>
        <div class="img_list" v-if="isShow">
          <img
            src="../../assets/images/sd12cddh.jpg"
           
            alt=""
          />
          <img
            src="../../assets/images/sjjwzqh.jpg"
            
            alt=""
          />
          <img
            src="../../assets/images/scsx.jpg"
            
            alt=""
          />
          <img
            src="../../assets/images/bwcx.jpg"
            
            alt=""
          />
        </div>
        <div class="img_list" v-else>
          <img
            src="../../assets/images/zgtsztjy.jpg"
            
            alt=""
          />
          <img
            src="../../assets/images/ershida.jpg"
           
            alt=""
          />
          <img
            src="../../assets/images/qljk.jpg"
           
            alt=""
          />
          <img
            src="../../assets/images/dysx.jpg"
            
            alt=""
          />
        </div>
        <div class="prev" >
          <img src="../../assets/images/prev.png" alt="" />
        </div>
        <div class="next">
          <img src="../../assets/images/next.png" alt="" />
        </div>
      </div>
    </div>
    <div class="szyIndex_main w1200" :class="{ isMobile: isMobile }">
      <div class="party_work">
        <div class="party_work_left" >
          <div class="h3_title">
            <span style="color: #b50000; font-size: 24px">党建</span>工作<span
              style="color: #ccc; margin-left: 5px"
              >PARTY</span
            >
          </div>
          <div class="list_card0" v-if="partywork === 0 && !isMobile">
            <div class="images pointer">
              <img :src="baseUrl + homepageData.partyList[0].picture" alt="" />
            </div>
            <div
              class="card_content"
              
            >
              <div class="title pointer">
                {{ homepageData.partyList[0].title }}
              </div>
              <div class="content pointer">
                {{ homepageData.partyList[0].content }}
              </div>
              <div class="time">
                {{ changeMoment(homepageData.partyList[0].inputTime) }}
              </div>
            </div>
          </div>
          <div class="list_card0" v-if="partywork === 1">
            <div class="images pointer">
              <img
                :src="baseUrl + homepageData.monitorList[0].picture"
                alt=""
                v-if="homepageData.monitorList[0].picture.indexOf('http')"
              />
              <img :src="homepageData.monitorList[0].picture" alt="" v-else />
            </div>
            <div
              class="card_content"
              
            >
              <div class="title pointer">
                {{ homepageData.monitorList[0].title }}
              </div>
              <div class="content pointer">
                {{ homepageData.monitorList[0].content }}
              </div>
              <div class="time">
                {{ changeMoment(homepageData.monitorList[0].inputTime) }}
              </div>
            </div>
          </div>
          <div class="list_card0" v-if="partywork === 2">
            <div class="images pointer">
              <img
                :src="baseUrl + homepageData.allianceList[0].picture"
                alt=""
              />
            </div>
            <div
              class="card_content"
              
            >
              <div class="title pointer">
                {{ homepageData.allianceList[0].title }}
              </div>
              <div class="content pointer">
                {{ homepageData.allianceList[0].content }}
              </div>
              <div class="time">
                {{ changeMoment(homepageData.allianceList[0].inputTime) }}
              </div>
            </div>
          </div>
          <div class="list_card0" v-if="partywork === 3">
            <div class="images pointer">
              <img
                :src="baseUrl + homepageData.civilizationList[0].picture"
                alt=""
              />
            </div>
            <div
              class="card_content"
              
            >
              <div class="title pointer">
                {{ homepageData.civilizationList[0].title }}
              </div>
              <div class="content pointer">
                {{ homepageData.civilizationList[0].content }}
              </div>
              <div class="time">
                {{ changeMoment(homepageData.civilizationList[0].inputTime) }}
              </div>
            </div>
          </div>
        </div>
        <div class="party_work_right">
          <div class="center_title">
            <div
              @mouseenter="partywork = 0"
              class="pointer"
              style="font-size: 16px"
              :class="{ highlight: partywork === 0 }"
             
            >
              党建工作
            </div>
            <div
              @mouseenter="partywork = 1"
              class="pointer"
              :class="{ highlight: partywork === 1 }"
              
            >
              纪检监察
            </div>
            <div
              @mouseenter="partywork = 2"
              class="pointer"
              :class="{ highlight: partywork === 2 }"
             
            >
              群团工作
            </div>
            <div
              @mouseenter="partywork = 3"
              class="pointer"
              :class="{ highlight: partywork === 3 }"
             
            >
              精神文明建设
            </div>
          </div>
          <div class="left_content">
            <div v-if="partywork === 0">
              <div
                class="list_card"
                v-for="(item, index) in homepageData.partyList"
                :key="index"
              >
                <div
                  class="card_title"
                 
                >
                  <span class="dian"></span>{{ item.title }}
                </div>
                <div class="card_time" v-if="!isMobile">{{ changeMoment(item.inputTime) }}</div>
              </div>
            </div>
            <div v-if="partywork === 1">
              <div
                class="list_card"
                v-for="(item, index) in homepageData.monitorList"
                :key="index"
              >
                <div
                  class="card_title"
                 
                >
                  <span class="dian"></span>{{ item.title }}
                </div>
                <div class="card_time" v-if="!isMobile">{{ changeMoment(item.inputTime) }}</div>
              </div>
            </div>
            <div v-if="partywork === 2">
              <div
                class="list_card"
                v-for="(item, index) in homepageData.allianceList"
                :key="index"
              >
                <div
                  class="card_title"
                 
                >
                  <span class="dian"></span>{{ item.title }}
                </div>
                <div class="card_time" v-if="!isMobile">{{ changeMoment(item.inputTime) }}</div>
              </div>
            </div>
            <div v-if="partywork === 3">
              <div
                class="list_card"
                v-for="(item, index) in homepageData.civilizationList"
                :key="index"
              >
                <div
                  class="card_title"
                  
                >
                  <span class="dian"></span>{{ item.title }}
                </div>
                <div class="card_time" v-if="!isMobile" >{{ changeMoment(item.inputTime) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="party_work">
        <div class="party_work_left">
          <div class="h3_title">
            <!-- <span style="color: #b50000; font-size: 24px">产品</span>
            和 
            <span style="color: #b50000; font-size: 24px">服务</span>
            <span
              style="color: #ccc; margin-left: 5px"
              >PRODUCT SERVICES</span
            > -->
            <span style="color: #b50000; font-size: 24px">业务</span>
         
            <span style="color: #b50000; font-size: 24px">领域</span>
            <span
              style="color: #ccc; margin-left: 5px"
              >BUSINESS AREA</span
            >
          </div>
          <!-- <div class="business">
            <div
              class="business_item"
             
            >
              <img src="../../assets/images/5.png" alt="" />
              <div>产品和服务</div>
            </div>
            <div
              class="business_item"
             
            >
              <img src="../../assets/images/6.png" alt="" />
              <div>客户案例</div>
            </div>
            <div
              class="business_item"
              
            >
              <img src="../../assets/images/7.png" alt="" />
              <div>解决方案</div>
            </div>
            <div
              class="business_item"
              
            >
              <img src="../../assets/images/8.png" alt="" />
              <div>您的需求</div>
            </div>
          </div> -->
          <div class="business">
            <div
              class="business_item"
              
            >
              <img src="../../assets/images/1.png" alt="" />
              <div>金融类</div>
            </div>
            <div
              class="business_item"
              
            >
              <img src="../../assets/images/2.png" alt="" />
              <div>类金融类</div>
            </div>
            <div
              class="business_item"
             
            >
              <img src="../../assets/images/3.png" alt="" />
              <div>基金类</div>
            </div>
            <div
              class="business_item"
              
            >
              <img src="../../assets/images/4.png" alt="" />
              <div>投资类</div>
            </div>
          </div>
        </div>
        <div class="party_work_left" style="margin: 0">
          <div class="h3_title">
            <span style="color: #b50000; font-size: 24px">山西证券</span
            >股票<span style="color: #ccc; margin-left: 5px">STOCK</span>
          </div>
          <div class="security">
            <div class="security_img">
              <img
                src="http://image.sinajs.cn/newchart/min/n/sz002500.gif"
                alt=""
                v-if="timeClass === 0"
              />
              <img
                src="http://image.sinajs.cn/newchart/daily/n/sz002500.gif"
                alt=""
                v-if="timeClass === 1"
              />
              <img
                src="http://image.sinajs.cn/newchart/weekly/n/sz002500.gif"
                alt=""
                v-if="timeClass === 2"
              />
              <img
                src="http://image.sinajs.cn/newchart/monthly/n/sz002500.gif"
                alt=""
                v-if="timeClass === 3"
              />
            </div>
            <div class="security_card">
              <div
                class="list_card"
                :class="{ card_height: timeClass === 0 }"
                @mouseenter="timeClass = 0"
              >
                分时线
              </div>
              <div
                class="list_card"
                :class="{ card_height: timeClass === 1 }"
                @mouseenter="timeClass = 1"
              >
                日K线
              </div>
              <div
                class="list_card"
                :class="{ card_height: timeClass === 2 }"
                @mouseenter="timeClass = 2"
              >
                周K线
              </div>
              <div
                class="list_card"
                :class="{ card_height: timeClass === 3 }"
                @mouseenter="timeClass = 3"
              >
                月K线
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="szyIndex_main special company" v-if="!isMobile">
      <div class="w1200 company_content">
        <div class="h3_title">
          <div>
            <span style="color: #b50000; font-size: 24px">旗下</span
            ><span style="font-size: 24px">公司</span
            ><span style="color: #ccc; margin-left: 5px">COMPANY</span>
          </div>
          <div>
            <span
              class="classify"
              :class="{ height_classify: classifyNum === 0 }"
              
              >全部</span
            >
            <span
              class="classify"
              :class="{ height_classify: classifyNum === 1 }"
              
              >全资公司</span
            >
            <span
              class="classify"
              :class="{ height_classify: classifyNum === 2 }"
             
              >控股公司</span
            >
          </div>
        </div>
        <div class="content">
          <div class="company_left" v-if="classifyNum === 0">
            <div class="arrow"></div>
            <div class="company_list" v-if="copyFromNum === 0">
              <div
                class="card_list"
                v-for="(item, index) in homepageData.companyList.slice(0, 10)"
                :key="index"
              >
                <div
                  class="card_item"
                  :class="{ height_classId: classId == item.id }"
                 
                >
                  <img
                    src="../../assets/images/list1.png"
                    alt=""
                    v-if="classId == item.id"
                  />
                  <img src="../../assets/images/list.png" alt="" v-else />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div class="company_list" v-if="copyFromNum === 1">
              <div
                class="card_list"
                v-for="(item, index) in homepageData.companyList.slice(10, 20)"
                :key="index"
              >
                <div
                  class="card_item"
                  :class="{ height_classId: classId == item.id }"
                 
                >
                  <img
                    src="../../assets/images/list1.png"
                    alt=""
                    v-if="classId == item.id"
                  />
                  <img src="../../assets/images/list.png" alt="" v-else />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div class="company_list" v-if="copyFromNum === 2">
              <div
                class="card_list"
                v-for="(item, index) in homepageData.companyList.slice(20)"
                :key="index"
              >
                <div
                  class="card_item"
                  :class="{ height_classId: classId == item.id }"
                  
                >
                  <img
                    src="../../assets/images/list1.png"
                    alt=""
                    v-if="classId == item.id"
                  />
                  <img src="../../assets/images/list.png" alt="" v-else />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div class="company_page">
              <div
                class="page"
                :class="{ page_classify: copyFromNum === 0 }"
                @mouseenter="copyFromNum = 0"
              ></div>
              <div
                class="page"
                :class="{ page_classify: copyFromNum === 1 }"
                @mouseenter="copyFromNum = 1"
              ></div>
              <div
                class="page"
                :class="{ page_classify: copyFromNum === 2 }"
                @mouseenter="copyFromNum = 2"
              ></div>
            </div>
          </div>
          <div class="company_left" v-if="classifyNum === 1">
            <div class="arrow"></div>
            <div class="company_list" v-if="copyFromNum === 0">
              <div
                class="card_list"
                v-for="(item, index) in homepageData.whollyOwnedList.slice(
                  0,
                  10
                )"
                :key="index"
              >
                <div
                  class="card_item"
                  :class="{ height_classId: classId == item.id }"
                  
                >
                  <img
                    src="../../assets/images/list1.png"
                    alt=""
                    v-if="classId == item.id"
                  />
                  <img src="../../assets/images/list.png" alt="" v-else />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div class="company_list" v-if="copyFromNum === 1">
              <div
                class="card_list"
                v-for="(item, index) in homepageData.whollyOwnedList.slice(10)"
                :key="index"
              >
                <div
                  class="card_item"
                  :class="{ height_classId: classId == item.id }"
                  
                >
                  <img
                    src="../../assets/images/list1.png"
                    alt=""
                    v-if="classId == item.id"
                  />
                  <img src="../../assets/images/list.png" alt="" v-else />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>

            <div class="company_page">
              <div
                class="page"
                :class="{ page_classify: copyFromNum === 0 }"
                @mouseenter="copyFromNum = 0"
              ></div>
              <div
                class="page"
                :class="{ page_classify: copyFromNum === 1 }"
                @mouseenter="copyFromNum = 1"
              ></div>
            </div>
          </div>
          <div class="company_left" v-if="classifyNum === 2">
            <div class="arrow"></div>
            <div class="company_list" v-if="copyFromNum === 0">
              <div
                class="card_list"
                v-for="(item, index) in homepageData.holdingList.slice(0)"
                :key="index"
              >
                <div
                  class="card_item"
                  :class="{ height_classId: classId == item.id }"
                  
                >
                  <img
                    src="../../assets/images/list1.png"
                    alt=""
                    v-if="classId == item.id"
                  />
                  <img src="../../assets/images/list.png" alt="" v-else />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>

            <div class="company_page">
              <div
                class="page"
                :class="{ page_classify: copyFromNum === 0 }"
                @mouseenter="copyFromNum = 0"
              ></div>
            </div>
          </div>
          <div class="company_right">
            <div class="header">
              <div class="title1">
                <span style="font-size: 24px">{{
                  "山西数据交易中心有限公司"
                }}</span>
              </div>
              <div class="xuanze">
                <div class="lianjie">
                  <a href="https://www.sxdataex.com/" target="_blank"
                    >官网链接</a
                  >
                </div>
                <div
                  class="detail"
                  
                >
                  查看简介
                </div>
              </div>
            </div>
            <div class="title-name">
              <img :src="baseUrl + '/profile/upload/2025/02/08/山西数据交易中心_20250208183441A015.jpg'" id="thumb" />
              <div class="d-detail" v-html="articlDetail.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="您的需求" :visible.sync="businessVisible" :width="isMobile?'80%':'26%'">
          <el-form :model="form" label-width="80px" :rules="rules" ref="form">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="form.name"
                autocomplete="off"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>

            <el-form-item label="联系方式" prop="mobile">
              <el-input
                v-model="form.mobile"
                autocomplete="off"
                placeholder="请输入联系方式"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input
                v-model="form.email"
                autocomplete="off"
                placeholder="请输入电子邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择客户类型">
                <el-option label="政府" value="2"></el-option>
                <el-option label="企业" value="1"></el-option>
                <el-option label="个人" value="3"></el-option>

              </el-select>
            </el-form-item>

            <el-form-item label="企业名称" prop="enterpriseName" v-if="form.type !='3'">
              <el-input
                v-model="form.enterpriseName"
                autocomplete="off"
                placeholder="请输入企业名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="您的需求" prop="demand">
              <el-input
                v-model="form.demand"
                autocomplete="off"
                type="textarea"
                placeholder="请输入您的需求"
              ></el-input>
            </el-form-item>
            <el-form-item class="form_btn">
              <el-button round>立即提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
  </div>
</template>

<script>
import szyCarousel from "@/components/szyCarousel/szyCarousel.vue";
import Config from "@/core/config";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "SzyIndex",
  components: {
    szyCarousel,
    vueSeamlessScroll,
  },
  data() {
    return {
      baseUrl: Config.baseUrl,
      loading: false,
      isMobile: false,
      listData: [
        {
          title: "无缝滚动第一行无缝滚动第一行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第二行无缝滚动第二行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第三行无缝滚动第三行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第四行无缝滚动第四行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第五行无缝滚动第五行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第六行无缝滚动第六行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第七行无缝滚动第七行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第八行无缝滚动第八行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第九行无缝滚动第九行",
          date: "2017-12-16",
        },
      ],
      counter: 0,
      centerNum: 0,
      partywork: 0,
      security: 0,
      isShow: false,
      timeClass: 0,
      classifyNum: 0,
      homepageData: {},
      copyFromNum: 0,
      articlDetail: {
        content:"<p style=\"text-indent: 32px;\"><span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;\">山西数据交易中心，经山西省人民政府批准，于2024年11月成立，系全省唯一持牌数据交易机构。围绕省委、省政府重大战略任务，以充分释放数据要素价值，促进数字技术与实体经济深度融合，助力产业数智化业转型和企业高质量发展为己任。业务涵盖数据流通交易、数据资产登记评估、数据产品孵化运营、数据资产化服务等领域，积极探索数据赋能实体经济的新路径，致力于将数据价值转化为推动经济社会高质量发展的新动力。</span></p><p><br style=\"white-space: normal;\"/></p><p style=\"text-indent:32px\"><span style=\"font-size: 16px;\"><br/></span></p>"
      },
      classId: null,
      businessVisible: false,
      form: {
        name: "",
        mobile: "",
        email: "",
        type: "",
        enterpriseName: "",
        demand: "",
      },
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择客户类型", trigger: "change" },
        ],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        demand:[
        { required: true, message: "请输入您的需求", trigger: "blur" },
        ]
      },
    };
  },
  created() {
    setTimeout(() => {
      this.homepageData = JSON.parse(localStorage.getItem("homepageData"));
    }, 300);
    this.startInfiniteLoop();
    setTimeout(() => {
      this.choiceCompany();
    }, 400);
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    this.stopInfiniteLoop();
  },
  methods: {
    changeMoment(date) {
      return date ? this.$moment(date).format("YYYY-MM-DD") : "";
    },

    handleResize() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    startInfiniteLoop() {
      this.intervalId = setInterval(() => {
        if (this.counter === 4) {
          this.counter = 0;
        } else {
          this.counter += 1;
        }
        // 你可以在这里添加更多的逻辑，比如触发更多的方法或者改变更多的数据
      }, 7000); // 每秒执行一次
    },
    stopInfiniteLoop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    onmouseover(index) {
      this.counter = index;
      this.stopInfiniteLoop();
    },
    newsCenterEnter(index) {
      this.centerNum = index;
    },
    
    
    
   
  },
};
</script>

<style lang="less" scoped>
.szyIndex {
  // border-bottom: 25px solid #eff2f7;
  background-color: #fff;
  .szyIndex_main {
    .content_carousel {
      display: flex;
      height: 250px;
      margin: 50px 0;
      .carousel_left {
        width: 425px;
        margin-right: 25px;
        position: relative;
        .big_img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .small_list {
          position: absolute;
          left: 50%;
          bottom: 20px;
          transform: translate(-50%, 0);
          height: 35px;
          display: flex;
          .small_img {
            width: 65px;
            height: 100%;
            margin-right: 10px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            span {
              position: absolute;
              display: inline-block;
              top: -6px;
              left: 29px;
              border-left: 6px dashed transparent;
              border-right: 6px dashed transparent;
              border-top: 0;
              border-bottom: 6px solid;
              color: #fff;
              font-size: 0;
              width: 0;
              height: 0;
            }
          }
        }
      }

      .carousel_right {
        flex: 1;
        .right_header {
          font-size: 18px;
          background-color: #f4f4f4;
          padding: 10px 0px;
          border-left: 4px solid #b50000;
          padding-left: 10px;
          display: flex;
          justify-content: space-between;
          .title {
            font-weight: 700;
            font-size: 18px;
          }
          .more {
            color: #a3a3a3;
            font-size: 12px;
            padding-right: 25px;
            margin-top: 3px;
            &:hover {
              color: #b50000;
            }
          }
        }
        .right_title {
          height: 65px;
          line-height: 65px;
          font-size: 22px;
          color: #333;
          font-weight: 700;
          width: 700px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          border-bottom: 1px dashed #ccc;
          &:hover {
            color: #b50000;
          }
        }
        .right_content {
          //height: 60px;
          font-size: 14px;
          color: #6c6c6c;
          padding: 20px 0 0 0;
          box-sizing: border-box;
          width: 820px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-bottom: 20px;
        }
        .right_footer {
          border-top: 1px dashed #ccc;
          display: flex;
          padding-top: 15px;
          .detail {
            width: 76px;
            height: 30px;
            background-color: #4f4f4f;
            line-height: 30px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            margin-right: 30px;
            &:hover {
              background-color: #b50000;
            }
          }

          .time {
            padding: 0 10px;
            line-height: 30px;
            color: #bdbdbd;
            font-size: 14px;
          }
        }
      }
    }
    .h3_title {
      border-left: 8px solid #b50000;
      padding-left: 10px;
      font-size: 24px;
      margin: 20px 0;
    }
    .special_title {
      display: flex;
      justify-content: space-between;
      .gengduo {
        width: 115px;
        height: 30px;
        background-color: #f2f2f2;
        font-size: 14px;
        line-height: 30px;
        text-align: center;
        margin-top: 17px;
        cursor: pointer;
        color: rgb(163, 163, 163);
        &:hover {
          color: #b50000;
        }
      }
    }
    .news_center {
      display: flex;
      padding-bottom: 25px;
      .center_left {
        flex: 1;
        padding-right: 30px;
        .center_title {
          height: 44px;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          display: flex;
          font-size: 16px;
          color: #333;
          padding: 4px;
          box-sizing: border-box;
          .pointer {
            font-size: 16px;
          }
          div {
            flex: 1;
            line-height: 34px;
            text-align: center;
          }
          .highlight {
            background-color: rgb(181, 0, 0);
            color: #fff;
          }
        }
        .left_content {
          margin-top: 30px;
          .list_card {
            display: flex;
            justify-content: space-between;
            line-height: 42px;
            .card_title {
              width: 400px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              position: relative;
              padding-left: 10px;
              .dian {
                border: 2px solid #000;
                border-radius: 50%;
                position: absolute;
                top: 20px;
                left: 0;
                margin-right: 5px;
              }
            }
            &:hover {
              color: #b50000;
              cursor: pointer;
            }
          }
          .list_card0 {
            display: flex;
            .images {
              width: 175px;
              height: 115px;
              margin-right: 20px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .card_content {
              flex: 1;
              .title {
                color: #646464;
                font-size: 18px;
                font-weight: 700;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin: 2px 0 15px 0;
                line-height: 25px;
                &:hover {
                  color: #b50000;
                  cursor: pointer;
                }
              }
              .content {
                font-size: 12px;
                color: #aaa;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                line-height: 20px;
              }
            }
          }
        }
      }
      .scroll_content {
        flex: 1;
        padding-left: 30px;
        .center_title {
          height: 44px;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          display: flex;
          font-size: 16px;
          color: #333;
          padding: 4px;
          box-sizing: border-box;
          line-height: 34px;
          i {
            color: rgb(181, 0, 0);
          }
        }
        // height: 270px;

        .seamless-warp {
          height: 300px;
          overflow: hidden;
          margin-top: 40px;
          ul {
            .item {
              line-height: 37px;
              display: flex;
              font-size: 14px;
              color: #646464;

              &:hover {
                color: rgb(181, 0, 0);
              }
              .copyFrom {
                font-weight: 800;
                width: 80px;
                text-align: right;
              }
              .line {
                width: 2px;
                height: 19px;
                background-color: #000;
                margin: auto 10px;
              }
              .title {
                width: 350px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              .date {
                flex: 1;
                text-align: right;
              }
            }
          }
        }
      }
    }
    .party_work {
      display: flex;
      padding: 20px 0;
      .party_work_left {
        flex: 1;
        margin-right: 25px;
        .h3_title {
          border-left: 8px solid #b50000;
          padding-left: 10px;
          font-size: 24px;
          margin: 20px 0;
        }
        .list_card0 {
          display: flex;
          margin-top: 50px;
          .images {
            width: 250px;
            height: 200px;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .card_content {
            flex: 1;
            .title {
              color: #333;
              font-size: 18px;

              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin: 2px 0 15px 0;
              line-height: 25px;
              &:hover {
                color: #b50000;
              }
            }
            .content {
              font-size: 14px;
              color: #333;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              line-height: 20px;
              &:hover {
                color: #b50000;
              }
            }
            .time {
              width: 100px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              background-color: #f4f4f4;
              color: #333;
              font-size: 14px;
              margin-top: 25px;
            }
          }
        }
        .business {
          display: flex;
          flex-wrap: wrap;
          margin-top: 30px;
          .business_item {
            width: 283px;
            height: 162px;
            text-align: center;
            border: 1px solid #dadada;
            margin-left: -1px;
            text-align: center;
            background-color: #f7f7f7;
            font-size: 18px;
            color: #333;
            img {
              margin: 30px 0 20px 0;
            }
            &:hover {
              color: #b50000;
              -webkit-transform: scale(1.1);
            }
          }
        }
        .security {
          margin-top: 30px;
          .security_img {
            width: 545px;
            height: 300px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .security_card {
            display: flex;
            width: 545px;
            .list_card {
              flex: 1;
              height: 22px;
              line-height: 22px;
              text-align: center;
              color: #333;
              font-size: 12px;
              background: #efeeef;
              -webkit-transition: width 0.7s, height 0.7s,
                -webkit-transform 0.7s;
              &:hover {
                transform: rotateX(360deg);
              }
            }
            .card_height {
              background: #b50000;
              color: #fff;
            }
          }
        }
      }
      .party_work_right {
        flex: 1;
        .center_title {
          height: 44px;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          display: flex;
          font-size: 16px;
          color: #333;
          padding: 4px;
          box-sizing: border-box;
          div {
            flex: 1;
            line-height: 34px;
            text-align: center;
          }
          .highlight {
            background-color: rgb(181, 0, 0);
            color: #fff;
          }
        }
        .left_content {
          margin-top: 30px;
          .list_card {
            display: flex;
            justify-content: space-between;
            line-height: 42px;
            font-size: 14px;
            color: #646464;
            .card_title {
              width: 500px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              position: relative;
              padding-left: 10px;
              .dian {
                border: 2px solid #000;
                border-radius: 50%;
                position: absolute;
                top: 20px;
                left: 0;
                margin-right: 5px;
              }
            }
            &:hover {
              color: #b50000;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .isMobile {
    font-size: 16px;
    margin: 0 15px;
    .content_carousel {
      margin: 15px 0;
      height: 300px;
      .carousel_right {
        .right_title {
          width: 100% !important;
        }
        .right_content {
          width: 100% !important;
          -webkit-line-clamp: 5;
          line-height: 1.5;
        }
      }
    }
    .news_center{
      display: block;
      
      .center_left{
        padding: 0;
        .center_title{
          .pointer{
            font-size: 12px !important;
          }
          

        }
      }
      .scroll_content{
        padding: 0;
        .seamless-warp {
          
          ul {
            .item {
              .copyFrom {
                font-weight: 800;
                width: 100px;
                text-align: right;
              }
              .line {
                width: 2px;
                height: 19px;
                background-color: #000;
                margin: auto 10px;
              }
              .title {
                width: 350px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              
            }
          }
        }
      }
    }
    .party_work{
      display: block;
      .party_work_left{
        margin: 0;
        .business{
          .business_item{
            width: 170px;
            height: 140px;
          }
        }
        .security{
          .security_img{
            width: 100%;
            height: 100%;
          }
          .security_card{
            width: 100%;
          }
        }
      }
      .party_work_right{
        .center_title{
          .pointer{
            font-size: 12px !important;
          }
          

        }
      }
    }
  }
  .special {
    background-color: #fafafa;
    padding: 20px 0;
    .content {
      position: relative;

      .img_list {
        img {
          margin-bottom: 20px;
          &:nth-child(2n) {
            margin-left: 85px;
          }
        }
      }
      .prev {
        position: absolute;
        left: -30px;
        top: 150px;
        width: 27px;
        height: 44px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .next {
        position: absolute;
        right: -30px;
        top: 150px;
        width: 27px;
        height: 44px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .company {
    margin-top: 130px;
    .company_content {
      .h3_title {
        display: flex;
        justify-content: space-between;
        .classify {
          color: #333;
          line-height: 24px;
          font-size: 14px;
          display: inline-block;
          padding: 0 16px;
        }
        .height_classify {
          background: #b50000;
          color: #fff;
        }
      }
      .content {
        height: 265px;
        display: flex;
        .company_left {
          width: 580px;
          box-sizing: border-box;
          background-color: #f2f2f2;
          padding: 30px;
          position: relative;
          .arrow {
            width: 0px;
            height: 0px;
            border-top: 20px solid transparent;
            border-right: 20px solid;
            border-bottom: 20px solid transparent;
            position: absolute;
            right: 0;
            top: 110px;
            border-right-color: #fafafa;
          }
          .company_list {
            display: flex;
            flex-wrap: wrap;
            .card_list {
              .card_item {
                width: 260px;
                height: 26px;
                line-height: 26px;
                padding: 5px 0;
                font-size: 14px;
                color: #333;
                img {
                  padding: 10px;
                  vertical-align: bottom;
                }
              }
              .height_classId {
                color: rgb(255, 255, 255);
                background-color: rgb(181, 0, 0);
              }
            }
          }
          .company_page {
            display: flex;
            margin-left: 10px;
            position: absolute;
            bottom: 20px;
            .page {
              width: 25px;
              height: 5px;
              background-color: #8e8e8e;
              margin-top: -5px;
              margin-right: 15px;
            }
            .page_classify {
              background-color: #b70002;
            }
          }
        }
        .company_right {
          margin-left: 65px;
          padding-top: 35px;
          flex: 1;
          .header {
            display: flex;
            justify-content: space-between;
            .title1 {
              color: #b50000;
              font-size: 24px;
              line-height: 44px;
            }
            .xuanze {
              display: flex;
              margin-top: 6px;
              border-bottom: 1px solid #e3e3e3;
              padding-bottom: 20px;
              .lianjie {
                width: 97px;
                height: 33px;
                background-color: #b70002;
                font-size: 14px;
                line-height: 29px;
                text-align: center;
                a {
                  color: #fff;
                }
              }
              .detail {
                width: 97px;
                height: 33px;
                background-color: #f2f2f2;
                font-size: 14px;
                line-height: 29px;
                text-align: center;
                margin-left: 10px;
                color: #646464;
              }
            }
          }
          .title-name {
            display: flex;
            margin-top: 25px;
            img {
              width: 230px;
              height: 120px;
              margin-right: 40px;
            }
            .d-detail {
              flex: 1;
              height: 120px;
              font-size: 14px;
              line-height: 29px;
              color: #898989;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>
